var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkOutline = function SvgBookmarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 3.262c-.817 0-1.5.684-1.5 1.5v14.5c0 1.173 1.462 1.903 2.4 1.2l4.6-3.45 4.6 3.45c.938.704 2.4-.026 2.4-1.2v-14.5c0-.816-.683-1.5-1.5-1.5zm.5 2h10v13l-4.1-3.074a1.51 1.51 0 0 0-1.8 0L7 18.262z"
  })));
};
export default SvgBookmarkOutline;